import styled from 'styled-components';
import ChatConversation from './ChatConversation';
import { colorSchema } from 'utils/style';

export default styled(ChatConversation)`
  .chat-conversation {
    display: flex;

    &__container {
      background-color: ${colorSchema('white')};
      height: 100%;
      overflow: scroll;
      padding: 0 2.4rem;
    }

    &__loading {
      align-items: center;
      display: flex;
      height: 100%;
      justify-content: center;
    }

    &__messages-date {
      color: ${colorSchema('grey700')};
      display: flex;
      font-size: 1.4rem;
      font-weight: 500;
      justify-content: center;
      margin: 1.6rem 0;
    }
  }
`;
